import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchActiveMachineCount } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const activeApplicationCountSlice = createAsyncThunk('get/activeApplicationCountSlice', FetchActiveMachineCount);

export const ActiveApplicationCountSlice = createSlice({
	name: 'activeApplicationCountSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[activeApplicationCountSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[activeApplicationCountSlice.rejected.toString()]: setAPIError,
		[activeApplicationCountSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[ActiveApplicationCountSlice.name]: ReturnType<typeof ActiveApplicationCountSlice.reducer>;
}

export const activeApplicationSelector = (state: IStates): any => {
	return state[ActiveApplicationCountSlice.name] || {};
};

export const useActiveApplicationCount = (): any => useSelector(activeApplicationSelector);

export const getActiveApplicationCount =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(activeApplicationCountSlice());
		return;
	};

export const resetActiveApplicationCount =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ActiveApplicationCountSlice.actions.RESET());
		return;
	};
